import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
//configure Apollo Client
// EMR GraphQL endpoint
const emr_graphql_http_link = createHttpLink({
  // these endpoints are depracted at the backend, no features using these endpoints are available.
    uri: process.env.VUE_APP_ENV === "production" 
    ? "https://api.vibrant-wellness.com/v1/lis/portal-calendar/graphql" 
    : 'https://www.vibrant-america.com/lisapi/v1/lis/calendar-staging/graphql'
});
const apolloClientEMR = new ApolloClient({
  link: emr_graphql_http_link,
  cache: new InMemoryCache(),
});

// PNS GraphQL endpoint
const pns_graphql_http_link = createHttpLink({
    uri: process.env.VUE_APP_ENV === "production" 
    ? "https://api.vibrant-america.com/v2/portal/trans-service/graphql" 
    : "https://api.vibrant-america.com/v2/portal/trans-service-st/graphql"
});
const apolloClientPNS = new ApolloClient({
  link: pns_graphql_http_link,
  cache: new InMemoryCache(),
});

// Apollo Client Collection
const apolloClients = {
  emr: apolloClientEMR,
  pns: apolloClientPNS,
};
export default apolloClients;